import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    expandedDiv: {
      backgroundColor: '#0e1319',
      padding: theme.spacing(2),
      border: '1px solid #2d343e',
      borderRadius: 8,
    },
    expandedDiv__leftContainer: {},
    expandedDiv__videoPlayerContainer: {
      height: 550,
      width: '100%',
    },
    expandedDiv__mediaContainer: {
      minHeight: 550,
      position: 'relative',
    },
    expandedDiv__closeSelectedMediaButton: {
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 9998,
    },
    expandedDiv__sceneActionContainer: {
      marginTop: theme.spacing(2),
      display: 'grid',
      gridTemplateColumns: 'repeat(5,1fr)',
      alignItems: 'center',
      gap: 16,
    },
    expandedDiv__actionContainer: {
      marginTop: theme.spacing(3),
      display: 'flex',
      justifyContent: 'space-between',
      gap: 16,
    },
    rightContainer: {},
    expandedDiv__talentContainer: {
      display: 'flex',
      gap: 16,
      alignItems: 'center',
    },
    expandedDiv__imageContainer: {
      width: 150,
      height: 100,
      overflow: 'hidden',
      borderRadius: 4,
      position: 'relative',
    },
    expandedDiv__image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    expandedDiv__detailContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    expandedDiv__iconsContainer: {
      display: 'flex',
      gap: 12,
    },
    expandedDiv__iconItem: {
      display: 'flex',
      gap: 6,
      alignItems: 'center',
    },
    expandedDiv__iconItem__hidden: {
      opacity: 0.4,
    },
    expandedDiv__icon: {
      fontSize: 16,
    },
    expandedDiv__commentSectionContainer: {
      marginTop: theme.spacing(1),
    },
    expandedDiv__commentSection__content: {},
    buttonIcon: {
      fontSize: '16px !important',
    },
    actionButton: {
      backgroundColor: '#1b232d',
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.customBlack.dark,
      },
    },
    noteTextAreaContainer: {
      margin: theme.spacing(2, 0),
    },
    notePaper: {
      marginTop: theme.spacing(2),
    },
    noteLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    groupedComments__container: {
      maxHeight: '600px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '& > *:not(:last-child)': {
        marginBottom: '20px',
      },
    },
    slateImages_container: {
      marginLeft: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& > *:last-child': {
        marginLeft: '10px',
        marginRight: '10px',
      },
      '& > *': {
        color: '#fff',
        background: '#212835',
        width: '100px',
      },
    },
    singleImageContainer: {
      width: '100%',
      minHeight: 550,
    },
    singleImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  }),
);
